import type { SITE_INSTALL_TESTS_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-install-tests-card/site-install-tests-card.fr.ts";

export const SITE_INSTALL_TESTS_CARD_ENGLISH_LOCALE = {
  title: "Installation tests",
  tabs: {
    vx: "Vx device tests ({count} tests)",
    v2v5: "V2/V5 device tests ({count} tests)",
  },
} satisfies typeof SITE_INSTALL_TESTS_CARD_FRENCH_LOCALE;
